
import Vue from "vue";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import { Contact } from "@/models/base";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppTab1 from "./ContactInfoDefault.vue";
import AppTab2 from "./ContactInfoAddresses.vue";
import AppTab3 from "./ContactInfoExtraFields.vue";
import AppTab4 from "./ContactInfoExtraInfo.vue";
import AppTab5 from "./ContactInfoAwsDocuments.vue";
import { UserConfigService } from "../../services/user-config-service";
import { getContactServiceByGroupId } from "../../utils/services/contact-services";
import { ContactService } from "../../utils/services/contact-service";
import AppTab6 from "./ContactInfoPriceRules.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";

export default Vue.extend({
	data(){
		return {
			tab: 0
		};
	},
	props: {
		contact: {
			type: Object as ()=>Contact,
			required: true
		},
		drawerButtonDisabled: Boolean
	},
	computed: {
		contactService():ContactService{
			return getContactServiceByGroupId(this.contact.GroupID);
		},
		title():string{
			return "";
		},
		canEdit():boolean {
			return UserConfigService.hasCurrentUserPermission((p)=>p.getPermissionsByBrowseID(this.contact.GroupID).hasWritePermissions());
		},
		canDelete():boolean {
			return UserConfigService.hasCurrentUserPermission((p)=>p.getPermissionsByBrowseID(this.contact.GroupID).hasDeletePermissions());
		},
		defaultTabs(): DefaultEditTab[] {
			return getVisibleDefaultEditTabs(this.contact.GroupID);
		},
		currentTabKey(): string {
			return this.defaultTabs[this.tab]?.key || "";
		},
		tabs(): any {
			return [...this.defaultTabs.map(t=>t.label()), ...this.extraFieldNamesConfig.getTabNames()];
		},
		extraFieldNamesConfig():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().getContactNamesByGroupID(this.contact.GroupID);
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldNamesConfig.getTabs();
		},
		extraFieldTabStart():number {
			return this.defaultTabs.length;
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		edit(){
			this.$router.push(this.contactService.getEditRoute(this.contact.ID));
		},
		async remove(){
			await this.contactService.delContacts([this.contact]);
			this.cancel();
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppTab1,
		AppTab2,
		AppTab3,
		AppTab4,
		AppTab5,
		AppTab6,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
